import { useOrientation } from '@/hooks/useOrientation';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useCallback } from 'react';
import { useFacilityStore } from '@/stores';
import FacilitySearchByFloor from './search-by-floor';
import FacilitySearchByCategory from './search-by-category';
import FacilitySearchControl from './search-control';
import { FACILITY_SEARCH_MODE } from '@/enums/facility';

const FacilitySearch = () => {
    const { isHorizontal } = useOrientation();
    const currentMode = useFacilityStore((state) => state.currentMode);

    const renderContent = useCallback(() => {
        switch (currentMode) {
            case FACILITY_SEARCH_MODE.SEARCH_BY_FLOOR:
                return <FacilitySearchByFloor />;
            case FACILITY_SEARCH_MODE.SEARCH_BY_CATEGORY:
                return <FacilitySearchByCategory />;
            default:
                return <FacilitySearchByFloor />;
        }
    }, [currentMode]);

    return (
        <div
            className={clsx(styles['shop-search'], {
                [styles['shop-search__horizontal']]: isHorizontal,
                [styles['shop-search__vertical']]: !isHorizontal,
            })}
        >
            <div
                className={clsx(styles['shop-search__control'], {
                    [styles['shop-search__control__horizontal']]: isHorizontal,
                    [styles['shop-search__control__vertical']]: !isHorizontal,
                })}
            >
                <FacilitySearchControl currentMode={currentMode} />
            </div>
            <div className={styles['shop-search__content']}>{renderContent()}</div>
        </div>
    );
};

export default FacilitySearch;
